<template>
  <div class="container-dashboard">
    <PageTitle :titles="[pageTitle]" hide-count />
    <!-- <h4
      class="col-xs-12 d-lg-block d-none font-weight-bold h4 mt-3 page-title text-uppercase"
      :style="`--accent-nav: ${routes[0]? routes[0].accentColor : ''};`"
    >
      {{pageTitle}}
    </h4>
    <h3 class="d-lg-none page-title col-xs-12">{{pageTitle}}</h3> -->
    <div class="row dashboard column mb-5 pb-5 pb-lg-0">
      <div
        v-for="(element, index) in routes"
        :key="index"
        class="col-xs-12 col-lg-3 col-sm-4 col-md-3 mb-3"
      >
        <CardNav :element="element" :description-prefix="descriptionPrefix" />
      </div>
    </div>
  </div>
</template>
<script>
import PageTitle from "@/pages/temps/components/PageTitle";
import CardNav from "../../components/shared/CardNav";
import store from "@/store";
import { redirectTo } from "@/common/constants/routes";
export default {
  components: {
    CardNav,
    PageTitle,
    redirectTo,
  },
  props: {
    pageTitle: {
      type: String,
      default: "",
    },
    descriptionPrefix: {
      type: String,
      default: "",
    },
    routesIndex: {
      type: Number,
      default: 2,
    },
  },
  computed: {
    routesPerms() {
      return store.state.routesPermissions;
    },
    routes() {
      return this.routesPerms[this.routesIndex].nestedRoutes;
    },
  },
  // methods: {
  //   redirectTo
  // },
  watch: {
    pageTitle: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.$emit("title-change", newValue);
        }
      },
    },
  },
  created() {
    // console.log(this.routes)
  },
};
</script>

<style scoped>
@media screen and (max-height: 645px) {
  .dashboard {
    padding-bottom: 11px;
  }
}

h4.d-lg-block {
  color: var(--accent-nav);
  filter: brightness(0.7);
}
</style>
